import { render } from "./project_summary.vue?vue&type=template&id=61455162&scoped=true"
import script from "./project_summary.js?vue&type=script&lang=js"
export * from "./project_summary.js?vue&type=script&lang=js"

import "./project_summary.vue?vue&type=style&index=0&id=61455162&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61455162"]])

export default __exports__